import { useEffect, useRef, useCallback, useMemo } from 'react';
import { useBoolean, useArray, useNumber, useStateful } from 'react-hanger';

const useInterval = (callback, delay, start = false) => {
  const savedCallback = useRef();

  useEffect(() => {
    if (start) {
      callback();
    }
  }, [start]);

  // 保存新回调
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // 建立 interval
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => {
        clearInterval(id);
      };
    }
  }, [delay]);
};

export default useInterval;
